export default function whatsAppSocket(socket) {
  socket.on('waLoginInfo', (status) => {
    // {"uid":"2184906-20230209153432-5d5nCSSV",
    // "detail":"2@YXFvfes4VNsOM8Wr8tGAfZ8Z3lD/iF89QAe78o8tjOQoOQnKdgXjdYycG
    // tw2fljgVrJllspHa+6M+g==,hRqJZHa3rKU+1JmcuGn4o37uYNZ3MIJ7pCaRN3rVpz0=,DgtEi+hoZFvhNeZrb6ELlMoxsTCuST4opNhdZ0AzqB4=,BtEin/R+Lyq24nM140Gys8/bc02qbuavXnTvh2inqOU=","status":1}
    if (status) {
      let msg = status
      if (typeof status === 'string') {
        msg = JSON.parse(status)
        sessionStorage.setItem('whatsAppSocket-waLoginInfo', status)
      } else {
        sessionStorage.setItem('whatsAppSocket-waLoginInfo', JSON.stringify(status))
      }
      $bus.$emit('whatsAppSocket-waLoginInfo', msg)
    }
  })
}
